module.exports = __webpack_public_path__ + "static/media/icons8-pdf-2-filled.27c9fca3.svg";